// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Perkelta ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Komanda',
  accControlKey: () => 'Uždaryti',
  accPositionAfter: () => 'po',
  accPositionBefore: () => 'prieš',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Laikydami paspaudę ' +
    p['keyPressed'] +
    ' ir SHIFT klavišus naudokite rodyklės klavišus, kad pakeistumėte tvarką.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Įveskite įvykdymo datą taip: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Įveskite mėnesį ir metus taip: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupė',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Reikšmė',
  checkboxSet_requiredMessageDetail: () => 'Būtina',
  checkbox_requiredMessageDetail: () => 'Būtina',
  close: () => 'Uždaryti',
  collection_noData: () => 'Nėra rodytinų duomenų.',
  collection_selectAllRows: () => 'Pasirinkti visas eilutes',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Pasirinkti eilutę ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Nerikiuojama',
  collection_sortEnabled: () => 'Rikiuojama',
  confirmation: () => 'Patvirtinimas',
  datePicker_currentDate: () => 'Dabartinė data',
  datePicker_goToToday: () => 'Eiti į šiandien',
  datePicker_label: () => 'Datos parinkiklis',
  datePicker_month: () => 'Mėnuo',
  datePicker_months: () => 'Mėnesiai',
  datePicker_next: () => 'Kitas',
  datePicker_nextDecade: () => 'Kitas dešimtmetis',
  datePicker_nextMonth: () => 'Kitas mėnuo',
  datePicker_prev: () => 'Ankstesnis',
  datePicker_prevDecade: () => 'Ankstesnis dešimtmetis',
  datePicker_prevMonth: () => 'Ankstesnis mėnuo',
  datePicker_restricted: () => 'Apribota',
  datePicker_selected: () => 'Pasirinkta',
  datePicker_today: () => 'Šiandien',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + ' savaitė',
  datePicker_weekNumColLabel: () => 'Savaitės numeris',
  datePicker_year: () => 'Metai',
  datePicker_years: () => 'Metai',
  error: () => 'Klaida',
  expandableList_expandCollapseInstructionText: () =>
    'Naudokite rodyklių klavišus norėdami išskleisti ir sutraukti',
  expandableList_groupCollapse: () => 'Sutraukta',
  expandableList_groupExpand: () => 'Išskleista',
  filePicker_addFiles: () => 'Įtraukti failų',
  filePicker_dropzonePrimaryText: () => 'Nuvilkimas',
  filePicker_dropzoneSecondaryText: () => 'Pasirinkite failą arba jį nuvilkite čia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Pasirinkite arba nuvilkite failus čia',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Šio tipo failų įkelti negalima: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Vienu kartu galima įkelti vieną failą',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    p['fileType'] + ' tipo failų įkelti negalima',
  filePicker_unknownFileTypeUploadError: () => 'nežinoma',
  formControl_clear: () => 'Valyti',
  formControl_day: () => 'Diena',
  formControl_helpAvailable: () => 'Žinynas pasiekiamas',
  formControl_hide: () => 'Slėpti',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Pasiekėte ribą  ' +
    ((
      {
        one: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character',
        few: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character',
        many: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('lt').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character') +
    '.',
  formControl_loading: () => 'Įkeliama',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Galite įvesti iki ' + p['MAX_LENGTH'] + ' simbolių.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' simboliai (-ių) liko.',
  formControl_month: () => 'Mėnuo',
  formControl_readOnly: () => 'Tik skaityti',
  formControl_requiredMessageDetail: () => 'Įveskite reikšmę.',
  formControl_show: () => 'Rodyti',
  formControl_year: () => 'Metai',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Baigti',
  gantt_labelLabel: () => 'Žyma',
  gantt_labelRow: () => 'Eilutė',
  gantt_labelStart: () => 'Pradėti',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nerasta jokių atitinkančių skyrių.',
  indexer_keyboardInstructionText: () => 'Norėdami pasirinkti reikšmę, paspauskite Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tarp ' + p['FROM_SECTION'] + '  ir ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Du kartus spustelėkite ir palaikykite, kad įjungtumėte gestų režimą, tada vilkite aukštyn arba žemyn, kad koreguotumėte reikšmę.',
  info: () => 'Informacija',
  inputDateMask_date_cleared: () => 'Data išvalyta',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tuščia',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'mmmm',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Įveskite ' + p['max'] + ' arba ankstesnę datą.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Įveskite ' + p['min'] + ' arba vėlesnę datą.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Įveskite galimą datą.',
  inputDatePicker_instruction: () => 'Paspauskite Tab, kad pasiektumėte kalendorių.',
  inputDatePicker_selectDate: () => 'Pasirinkite datą',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Įveskite mėnesį ir metus, kurie sutaptų su ' + p['max'] + ' arba būtų ankstesni.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Įveskite mėnesį ir metus, kurie sutaptų su ' + p['min'] + ' arba būtų vėlesni.',
  inputNumber_converterParseError: () => 'Įveskite skaičių.',
  inputNumber_decrease: () => 'Sumažinti',
  inputNumber_increase: () => 'Padidinti',
  inputPassword_hidden: () => 'Slaptažodis paslėptas',
  inputPassword_hide: () => 'Slėpti slaptažodį',
  inputPassword_show: () => 'Rodyti slaptažodį',
  inputSensitiveText_hidden: () => 'Slaptas tekstas paslėptas',
  list_msgFetchCompleted: () => 'Įkelta',
  list_msgFetchingData: () => 'Įkeliama',
  list_suggestion: () => 'Pasiūlymas',
  messageToast_allMessagesClosed: () => 'Visi informaciniai pranešimai uždaryti.',
  message_close: () => 'Uždaryti',
  message_confirmation: () => 'Pavyko',
  message_error: () => 'Klaida',
  message_info: () => 'Informacija',
  message_navigationFromMessagesRegion: () =>
    'Įeinama į pranešimų sritį. Paspauskite F6, kad grįžtumėte prie ankstesnio pasirinkto elemento.',
  message_navigationToMessagesRegion: () =>
    'Pranešimų srityje yra naujų pranešimų. Paspauskite F6, kad grįžtumėte prie naujausių pranešimų srities.',
  message_warning: () => 'Perspėjimas',
  noData_message: () => 'Nėra rodytinų elementų',
  overflowItemLabel: () => 'Daugiau skirtukų',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Vykdoma',
  radio_helpForRadio: () => 'Išrinkimo mygtuko žinynas',
  radio_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  selectMultiple_apply: () => 'Taikyti',
  selectMultiple_back: () => 'Atgal',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Naudokite rodyklių kairėn ir dešinėn klavišus, kad pažymėtumėte pasirinktas reikšmes.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Paspauskite Grįžti arba Naikinti, kad pašalintumėte pasirinktą reikšmę.',
  selectMultiple_selectedValues: () => 'Parinktos reikšmės',
  selectMultiple_showSelectedValues: () => 'Rodyti tik pasirinktas reikšmes.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Pasirinkta reikšmių: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Įtraukti į sąrašą',
  select_addToListAvailable: () => 'Įtraukimas į sąrašą prieinamas',
  select_moreSearchOptions: () => 'Daugiau paieškos parinkčių',
  select_moreSearchOptionsAvailable: () => 'Daugiau ieškos parinkčių prieinama',
  select_noMatchesFound: () => 'Atitikmenų nerasta.',
  select_oneMatchFound: () => 'Rastas vienas atitikmuo',
  select_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' atitikmenų',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' arba daugiau atitikmenų',
  selectorAll_deselectAll: () => 'Atžymėti viską',
  selectorAll_selectAll: () => 'Pasirinkti viską',
  selector_selected: () => 'Žymės langelis pažymėtas',
  selector_unselected: () => 'Žymės langelis nepažymėtas',
  tabBarNavigationList_removeCueText: () => 'Pašalinama',
  timeComponent_tooltipZoomIn: () => 'Artinti',
  timeComponent_tooltipZoomOut: () => 'Tolinti',
  train_current: () => 'Dabartinis',
  train_message_type: () => 'Pranešimo tipas',
  train_not_visited: () => 'Neaplankyta',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    p['currentStep'] + ' žingsnis iš ' + p['numberOfSteps'],
  train_visited: () => 'Aplankyta',
  userAssistance_learnMore: () => 'Sužinokite daugiau',
  userAssistance_required: () => 'Būtina',
  vis_clearSelection: () => 'Išvalyti pasirinktą sritį',
  vis_drillable: () => 'Kilmė analizuojama',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' iš ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Nuosvyros pasirinkimas',
  vis_marqueeZoomTooltip: () => 'Nuosvyros mastelio keitimas',
  vis_noData: () => 'Nėra rodytinų duomenų',
  vis_panTooltip: () => 'Slinkti',
  vis_stateLoaded: () => 'Įkelta',
  vis_stateLoading: () => 'Įkeliama',
  vis_stateSelected: () => 'Pasirinkta',
  vis_stateUnselected: () => 'Nepasirinkta',
  warn: () => 'Perspėjimas'
};
export default bundle;
